import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=550c7ba0&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=js"
export * from "./LandingHero.vue?vue&type=script&lang=js"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=550c7ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c7ba0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingList: require('/src/components/landing/LandingList.vue').default})
